var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 6.333C11.666 7.38773 11.3533 8.41877 10.7673 9.29575C10.1813 10.1727 9.3485 10.8563 8.37408 11.26C7.39966 11.6636 6.32743 11.7693 5.29295 11.5636C4.25848 11.3579 3.30823 10.8501 2.56236 10.1044C1.81648 9.35862 1.30848 8.40846 1.1026 7.37403C0.896709 6.33959 1.00218 5.26734 1.40567 4.29284C1.80915 3.31835 2.49254 2.48538 3.36942 1.89926C4.2463 1.31314 5.27728 1.0002 6.332 1C7.03243 0.999869 7.72602 1.13771 8.37316 1.40566C9.02031 1.67361 9.60833 2.06642 10.1036 2.56165C10.599 3.05687 10.9919 3.64482 11.26 4.29192C11.528 4.93901 11.666 5.63258 11.666 6.333V6.333Z",
    stroke: "#707485",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9986 13L10.0986 10.1",
    stroke: "#707485",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.ce863594174eb22e146976b9645c818a.svg";
export { ForwardRef as ReactComponent };